// Shared by the Configurare tabs: one save at a time, the server's (Romanian) messages shown as they are,
// and the round trip for a rename of something in use (409 CONFIRM_USED -> warning -> same call with confirmUsed).
// A tab using it has `load()` and, when it renames things, <ConfirmUsedDialog ref="confirmUsed" />.
export default {
  data() {
    return {
      saving: false,
      loading: false,
      loaded: false,
    };
  },
  // keep-alive: reload whenever the tab is shown again, other tabs may have changed what this one lists
  activated() {
    this.reload();
  },
  methods: {
    async reload() {
      this.loading = true;
      try {
        await this.load();
        this.loaded = true;
      } catch (error) {
        this.fail(error, 'Eroare la încărcarea datelor');
      } finally {
        this.loading = false;
      }
    },
    fail(error, fallback) {
      const message = error?.response?.data?.message;
      this.$emit('error', (Array.isArray(message) ? message.join('. ') : message) || fallback);
    },
    /**
     * send(extra) makes the call; extra is {} the first time and { confirmUsed: true } after the user accepted
     * the warning. `confirm` is what ConfirmUsedDialog shows (without it a 409 is just an error).
     */
    async change(send, { done, fallback = 'Eroare la salvare', confirm } = {}) {
      if (this.saving) return false;
      this.saving = true;
      try {
        try {
          await send({});
        } catch (error) {
          const data = error?.response?.data;
          if (!confirm || error?.response?.status !== 409 || data?.code !== 'CONFIRM_USED') throw error;
          this.saving = false;
          const accepted = await this.$refs.confirmUsed.ask({ ...confirm, usage: data.usage || {} });
          if (!accepted) return false;
          this.saving = true;
          await send({ confirmUsed: true });
        }
        if (done) this.$emit('success', done);
        await this.reload();
        return true;
      } catch (error) {
        this.fail(error, fallback);
        // a half-done reorder or a switch that flipped on screen: show what the server has
        this.reload();
        return false;
      } finally {
        this.saving = false;
      }
    },
  },
};
